export default __webpack_public_path__ + "static/media/pfp-green.1d1785e6.svg";